import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { FaDownload } from "react-icons/fa";

const ReportGenerate = ({ excelData, fileName }) => {
  if (!Array.isArray(excelData)) {
    console.error("Excel data is not an array or is undefined.");
    return null;
  }

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  // Define column widths
  const wscols = [
    { wch: 30 }, // ModuleName
    { wch: 15 }, // RowType
    { wch: 20 }, // Particulars
    { wch: 50 }, // KeyInsights
    { wch: 10 }, // TotalValue
    { wch: 20 }, // Status
    { wch: 50 }, // Recommendations
    { wch: 50 }, // Other Details
    { wch: 20 }, // PrimaryType
    { wch: 20 }, // SecondaryType
    { wch: 50 }, // KeyFunctions
    { wch: 10 }, // ReportID
  ];

  const addStyles = (workSheet) => {
    Object.entries(workSheet).forEach(([key, cell]) => {
      if (key.match(/^[A-L]1$/)) {
        // Apply styles to header row
        cell.s = {
          alignment: {
            vertical: "center",
            horizontal: "center",
          },
          font: { bold: true, sz: 12 },
        };
      }
    });
  };

  const formatOtherDetails = (otherDetails) => {
    if (!Array.isArray(otherDetails)) return "";
    return otherDetails.map((item) => `${item.name}: ${item.value}`).join("\n");
  };

  const formatFunctions= (otherDetails) => {
    if (!Array.isArray(otherDetails)) return "";
    return otherDetails.map((item) => `${item.name}`).join("\n");
  };

  const transformData = (data) => {
    return data.map((item) => ({
      ModuleName: item.ModuleName || "",
      RowType: item.RowType || "Data",
      Particulars: item.Particulars || "",
      KeyInsights: item.KeyInsights || "",
      TotalValue: item.TotalValue || "",
      Status: item.Status || "",
      Recommendations: item.Recommendations || "",
      OtherDetails: formatOtherDetails(item.OtherDetails), // Convert array to string
      PrimaryType: item.PrimaryType || "",
      SecondaryType: item.SecondaryType || "",
      KeyFunctions: item.KeyFunctions || "",
      // ReportID: item.ReportID || "",
      // PageName: item.PageName || "",
      Functions: formatFunctions(item.Functions), // Convert array to string

    }));
  };

  const exportToExcel = async () => {
    const transformedData = transformData(excelData);
    const ws = XLSX.utils.json_to_sheet(transformedData);
    ws["!cols"] = wscols;
    ws["!autofilter"] = { ref: ws["!ref"] };
    addStyles(ws);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div>
      <button
        style={{
          fontSize: "14px",
          padding: "12px",
          border: "none",
          width: "60px",
          borderRadius: "6px",
          boxShadow: "0px 4px 4px 0px #00000040",
          background: "#1453A0",
          color: "white",
          height: "47px",
          textAlign: "center",
          display: "grid",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={exportToExcel}
        title="Export in Excel"
      >
        <FaDownload />
      </button>
    </div>
  );
};

export default ReportGenerate;
